import { UserProfile } from "@sunrun/sales-experience-shared";
import {
  AmplifyGet,
  AmplifyPost,
} from "@sunrun/sales-experience-shared/amplify-api-wrapper";
import { logger } from "./logger";
import type { NavigationItemsResponse } from "adapters/navigation";

class SalesExpApi {
  static apiName = "SalesExp";
  static getUserProfile(hybridToken: string): Promise<UserProfile> {
    return AmplifyGet<{ userProfile: UserProfile }>(
      "Get User Profile",
      this.apiName,
      "/getUserProfile",
      {
        headers: {
          Authorization: `Bearer ${hybridToken}`,
        },
      },
      logger,
      {
        expectedErrorCodes: [401, 403],
      }
    ).then((res) => {
      return res.userProfile;
    });
  }

  static tableauLogin(email: string): Promise<{
    credentials?: { token: string };
    error?: string;
  }> {
    return AmplifyPost<{ credentials?: { token: string }; error?: string }>(
      "Tableau Login",
      this.apiName,
      "/tableau/login",
      {
        body: { userEmail: email },
      },
      logger
    );
  }

  static getNavigationItems(
    hybridToken: string
  ): Promise<NavigationItemsResponse> {
    return AmplifyGet<NavigationItemsResponse>(
      "Get Navigation Items",
      "NavigationItemsApi",
      "/navigation/items",
      {
        headers: {
          Authorization: `Bearer ${hybridToken}`,
        },
      },
      logger,
      {
        expectedErrorCodes: [401, 403],
      }
    );
  }

  static getAISalesAppJwt(
    hybridToken: string
  ): Promise<{ jwt: string; email: string; employeeId: string }> {
    return AmplifyPost<{ jwt: string; email: string; employeeId: string }>(
      "Get AI Sales App JWT",
      this.apiName,
      "/getAISalesAppJwt",
      {
        headers: {
          Authorization: `Bearer ${hybridToken}`,
        },
      },
      logger,
      {
        expectedErrorCodes: [401, 403],
      }
    );
  }

  static getRetailStoreAddresses(hybridToken: string): Promise<any> {
    return AmplifyGet<any>(
      "Get Retail Store Addresses",
      this.apiName,
      "/getRetailStoreAddresses",
      {
        headers: {
          Authorization: `Bearer ${hybridToken}`,
        },
      },
      logger
    );
  }
}

export { SalesExpApi };
